import api from '../api/axios';

export const createRequirement = (formData) => api.post('/newRequirment', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
}).then((r) => r.data);

export const getRequirements = () => api.get('/getrequirements').then((r) => r.data);
export const getTeamRequirements = (userId, scope = 'all') => (
  api.get(`/getTeamrequirements/${userId}`, { params: { scope } }).then((r) => r.data)
);
export const getHomeReqData = (userId) => api.get(`/getHomeReqData/${userId}`).then((r) => r.data);
export const getRequirementById = (id) => api.get(`/getrequirements/${id}`).then((r) => r.data);
export const claimRequirement = (id, body) => api.put(`/claim/${id}`, body).then((r) => r.data);
export const unclaimRequirement = (id, body) => api.put(`/unclaim/${id}`, body).then((r) => r.data);
export const getActions = (id, userId) => api.get(`/actions/${id}/${userId}`).then((r) => r.data);
export const getAdminRequirements = () => api.get('/admingetrequirements').then((r) => r.data);
export const getAdminRequirementById = (id) => api.get(`/admingetrequirements/${id}`).then((r) => r.data);
export const deleteRequirement = (regId) => api.delete(`/deleteRequirement/${regId}`).then((r) => r.data);

export const editRequirement = (id, body) => {
  if (body instanceof FormData) {
    return api.put(`/editRequirement/${id}`, body, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  }
  return api.put(`/editRequirement/${id}`, body).then((r) => r.data);
};

export const assignRequirement = (userId, reqId) => api.post(`/assignReq/${userId}/${reqId}`).then((r) => r.data);
export const unassignRequirement = (userId, reqId) => api.post(`/unassignReq/${userId}/${reqId}`).then((r) => r.data);
export const updateAssignedUserUploadStatus = (requirementId, userId, profileUploadEnabled) =>
  api.put(`/api/requirements/${requirementId}/assigned-users/${userId}/upload-status`, { profileUploadEnabled }).then((r) => r.data);
export const getClaimedByCount = (id) => api.get(`/api/requirements/${id}/claimedByCount`).then((r) => r.data);
export const getClaimedByDetails = (id) => api.get(`/api/requirements/${id}/claimedByDetails`).then((r) => r.data);
export const updateRequirementType = (id, requirementtype) =>
  api.patch(`/api/requirements/${id}/requirement-type`, { requirementtype }).then((r) => r.data);
export const updateRequirementPriority = (id, priority) =>
  api.patch(`/api/requirements/${id}/priority`, { priority }).then((r) => r.data);
export const importRequirements = (rows, uploadedBy) =>
  api.post('/api/requirements/import', { rows, uploadedBy }).then((r) => r.data);

async function parseBlobApiError(error, fallback = 'Unable to fetch JD PDF.') {
  const blob = error?.response?.data;
  if (!(blob instanceof Blob)) {
    return error;
  }

  try {
    const text = await blob.text();
    const json = JSON.parse(text);
    const err = new Error(json.message || json.msg || fallback);
    err.status = error.response?.status;
    return err;
  } catch (parseError) {
    return error;
  }
}

async function fetchRequirementJdBlob(requirementId, { download = false } = {}) {
  try {
    const response = await api.get(`/api/requirements/${requirementId}/jd`, {
      responseType: 'blob',
      params: download ? { download: '1' } : {},
    });

    const contentType = response.headers?.['content-type'] || response.data?.type || '';
    if (contentType.includes('application/json')) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      const err = new Error(json.message || json.msg || 'Unable to fetch JD PDF.');
      err.status = response.status;
      throw err;
    }

    return response.data;
  } catch (error) {
    throw await parseBlobApiError(error);
  }
}

export async function viewRequirementJd(requirementId, fileName = 'job-description.pdf') {
  const blob = await fetchRequirementJdBlob(requirementId, { download: false });
  const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  window.open(url, '_blank', 'noopener,noreferrer');
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  return fileName;
}

export async function downloadRequirementJd(requirementId, fileName = 'job-description.pdf') {
  const blob = await fetchRequirementJdBlob(requirementId, { download: true });
  const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || 'job-description.pdf';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}
